import React from "react";

function DoorSearch() {
    return (
        <div>
            <h2>Drugs, Alcohol & Search Procedures</h2>
            <p>
                Door Supervisors play a key role in preventing illegal substances and dangerous items from entering premises. This module covers how to identify signs of substance misuse and how to conduct lawful, respectful searches.
            </p>

            <h3>Recognizing Substance Misuse</h3>
            <ul>
                <li>Alcohol: slurred speech, unsteady movement, aggression</li>
                <li>Drugs: dilated pupils, erratic behavior, paranoia</li>
                <li>Inhalants: disorientation, chemical smell, dizziness</li>
                <li>Be alert to signs of overdose or medical distress</li>
            </ul>

            <h3>Legal Grounds for Searching</h3>
            <ul>
                <li>Searches must be <strong>consensual</strong> unless conducted by police</li>
                <li>Clearly explain the reason and request permission</li>
                <li>Refusal may result in denied entry — not forced search</li>
                <li>Always follow venue policy and licensing conditions</li>
            </ul>

            <h3>Search Procedures</h3>
            <ul>
                <li>Use same-gender staff for physical searches</li>
                <li>Conduct searches in a respectful, non-invasive manner</li>
                <li>Use metal detectors or wands where available</li>
                <li>Document all searches and findings</li>
            </ul>

            <h3>Handling Seized Items</h3>
            <ul>
                <li>Secure and label any confiscated items</li>
                <li>Report to management and/or police as required</li>
                <li>Never dispose of illegal substances yourself</li>
                <li>Record the incident in detail</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> A patron appears intoxicated and refuses a bag search. What are your options, and how do you handle the situation professionally?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/alcohol-licensing" target="_blank" rel="noreferrer">UK Gov – Alcohol Licensing</a></li>
                <li><a href="https://www.drugwise.org.uk/" target="_blank" rel="noreferrer">DrugWise – Substance Awareness</a></li>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Search Training</a></li>
            </ul>
        </div>
    );
}

export default DoorSearch;
